module.exports = __webpack_public_path__ + "img/zawaroom.4f98b485.svg";